var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.packageOrderTypeTitle)?_c('a-badge',{class:['trawl-badge-success'],attrs:{"count":_vm.packageOrderTypeTitle}}):_c('a-badge',{class:['trawl-badge-success'],attrs:{"count":'Not Set'}})
}
var staticRenderFns = []

export { render, staticRenderFns }